import React, { useState, useEffect, useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import ChartContext from "../../context/ChartContext";
import ReactECharts from "echarts-for-react";

export const GeoDataChart = ({ data }) => {
    const [geoData, setGeoData] = useState([]);
    const [options, setOptions] = useState({});
    //   const [hoveredValue, setHoveredValue] = useState(null)
    const { setHoveredValue, hoveredValue } = useContext(ChartContext);

    useEffect(() => {
        if (typeof data === "object" && data.length > 0) {
            const toRad = (value) => (value * Math.PI) / 180;

            const haversineDistance = (lat1, lng1, lat2, lng2) => {
                const R = 6371e3; // Earth's radius in meters
                const φ1 = toRad(lat1);
                const φ2 = toRad(lat2);
                const Δφ = toRad(lat2 - lat1);
                const Δλ = toRad(lng2 - lng1);

                const a =
                    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                    Math.cos(φ1) *
                        Math.cos(φ2) *
                        Math.sin(Δλ / 2) *
                        Math.sin(Δλ / 2);
                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                return R * c; // in meters
            };

            const distances = [0];
            for (let i = 1; i < data.length; i++) {
                const prev = data[i - 1];
                const curr = data[i];
                const d = haversineDistance(
                    prev.lat,
                    prev.lng,
                    curr.lat,
                    curr.lng
                );
                distances.push(distances[i - 1] + d);
            }

            const altitudes = data.map((p) => p.alt);

            setOptions({
                chart: {
                    type: "line",
                    zoomType: "x",
                    backgroundColor: "#242a36",
                },
                title: {
                    text: "Altitude over Distance",
                    style: { color: "#ccdaf0" },
                },
                xAxis: {
                    categories: distances.map((d) => parseInt(d)), // in m
                    title: {
                        text: "Distance (m)",
                        style: { color: "#ccdaf0" },
                    },
                    labels: {
                        style: { color: "#ccdaf0" },
                    },
                },
                yAxis: {
                    title: {
                        text: "Altitude (m)",
                        style: { color: "#ccdaf0" },
                    },
                    labels: { style: { color: "#ccdaf0" } },
                },
                plotOptions: {
                    series: {
                        point: {
                            events: {
                                mouseOver: function () {
                                    const index = this.index;
                                    const dataPoint = data[index];
                                    setHoveredValue(dataPoint);
                                },
                                mouseOut: function () {
                                    setHoveredValue(null);
                                },
                            },
                        },
                    },
                },
                series: [
                    {
                        name: "Altitude",
                        data: altitudes,
                        color: "#00ffd8",
                        lineWidth: 1,
                    },
                ],
                tooltip: {
                    formatter: function () {
                        const index = this.point.index;
                        const dataPoint = data[index];
                        return `<b>Distance:</b> ${distances[index].toFixed(
                            2
                        )} m<br/><b>Altitude:</b> ${
                            dataPoint.alt.toFixed(2)
                        } m<br/><b>Lat:</b> ${dataPoint.lat.toFixed(6)}<br/><b>Lng:</b> ${
                            dataPoint.lng.toFixed(6)
                        }`;
                    },
                },
                legend: { enabled: false },
                credits: { enabled: false },
            });
        }

        return () => {
            setHoveredValue(null);
            setGeoData([]);
            setOptions({});
        };
    }, []);

    return (
        <div>
            {options.series ? (
                <HighchartsReact highcharts={Highcharts} options={options} />
            ) : (
                <div style={{ color: "white" }}>Loading chart...</div>
            )}
        </div>
    );
};

export const LineChart = ({ type = "line" }) => {
    const options = {
        backgroundColor: "transparent",
        title: {
            text: "Monthly Stats",
            textStyle: { color: "#fff", fontSize: "10px" },
        },
        tooltip: {
            trigger: "axis",
        },
        // legend: {
        //   data: ['Project A', 'Project B'],
        //   textStyle: { color: '#fff' },
        // },
        xAxis: {
            type: "category",
            data: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
            axisLine: { lineStyle: { color: "#fff" }, show: true },
            axisLabel: { color: "cyan", show: true, fontSize: "10px" }, // Hide X-axis labels
            axisTick: { show: false }, // Hide ticks
            splitLine: { show: false },
        },
        yAxis: {
            type: "value",
            // axisLine: { lineStyle: { color: "#fff" } },
            axisLabel: { color: "cyan", show: true, fontSize: "10px" },
            splitLine: { show: false },
            axisTick: { show: false }, // Hide ticks
            axisLine: {
                show: true,
                lineStyle: {
                    color: "#fff", // Y-axis vertical line color
                    width: 1,
                },
            },
        },
        series: [
            {
                name: "Adani Mines",
                type: type,
                data: [120, 132, 101, 134, 90, 230],
                smooth: true,
                lineStyle: {
                    color: "cyan", // Graph line color (tailwind sky-500)
                    width: 1,
                },
                symbol: "circle",
                symbolSize: 4,
                itemStyle: {
                    color: "cyan",
                },
            },
        ],
        grid: { left: 40, right: 20, bottom: 30, top: 60 },
    };

    return (
        <ReactECharts
            option={options}
            style={{ height: "100%", width: "50%" }}
        />
    );
};
